import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-page-404',
  imports: [RouterModule, ButtonModule],
  template: `
  <div class="bg-surface-50  flex items-center justify-center min-h-screen min-w-[100vw] overflow-hidden">
    <div class="content ">
        <div class=" w-full bg-surface-0 py-20 px-8 sm:px-20">
            <div class="items-center mb-8">
                <img src="images/logo/logo_sapienza.png" class="size-fit min-h-[5rem] max-h-[12rem]">
            </div>
          <div class="flex flex-col items-center justify-center gap-6">
             <span class="font-semibold text-3xl">Error 404</span>  
             <span class="font-semibold text-2xl">Ci Dispiace!</span>  
            <span class="text-lg">La pagina che stai cercando non Esiste o è stata Eliminata.</span>
            <span class="text-lg">Premi su Torna alla Home per continuare a Navigare</span>
            <p-button routerLink="/home">Torna alla Home</p-button>
          </div>
        </div>
    </div>
</div>`
  ,
  styleUrl: './page-404.component.scss'
})
export class Page404Component {

}
